// extracted by mini-css-extract-plugin
export var active = "w_bd";
export var arrow = "w_9";
export var icon = "w_bz";
export var link = "w_bs";
export var links = "w_b1";
export var scrolled = "w_y";